import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { YearSummary } from '../../model/year-summary.js';
import { summaryQueries } from './summary-queries.js';

export const useSummaryQuery = (
  year: number | null = null,
  month: number | null = null,
  category: string | null = null,
): UseQueryResult<YearSummary> => useQuery(summaryQueries.year(year, month, category));
